'use strict';

var $ = require('jquery');
import {debounce} from '../components/custom-lodash';

module.exports = {
    init: function () {
        var $variationSlick = $('.product-variations-slick');

        $variationSlick.not('.slick-initialized').slick({
            autoplay: false,
            infinite: false,
            rtl: document.documentElement.lang === 'ar' ? true : false,
            arrows: true,
            dots: true,
            dotsClass: 'slick-dots-custom',
            slidesToShow: 4,
            slideToScroll: 1,
            draggable: false,
            adaptiveHeight: true,
            variableWidth: true,
            prevArrow: $('.us-layout-container .slick-prev')[0],
            nextArrow: $('.us-layout-container .slick-next')[0]
        });

        var $carouselContainer = $('.us-layout-container');
        if ($carouselContainer.find('.grid-tile').length < 5) {
            $carouselContainer.find('.nav-arrows').hide();
            $carouselContainer.addClass('no-margin');
        }

        $carouselContainer.find('.prehide').removeClass('prehide');

        $(document).on(
            'resize orientationchange',
            debounce(function () {
                $variationSlick.slick('resize');
            }, 100)
        );
    }
};
